import React from 'react';
import { ComponentProps } from '@app/participant-fields';
import { Criterion } from 'queries';
import { CriterionCheckboxSelect } from './CriterionCheckboxSelect';
import { CriterionSelect } from './CriterionSelect';

export const CriterionMagicSelect = ({
  field,
  onChange,
  value: criterion,
  allowedFields,
  criteria,
  ...props
}: ComponentProps<Criterion>) => {
  const options = props.options || field.choices || [];
  if (options && options.length <= 3) {
    return (
      <CriterionCheckboxSelect
        field={field}
        onChange={onChange}
        value={criterion}
        allowedFields={allowedFields}
        criteria={criteria}
        {...props}
      />
    );
  }

  return (
    <CriterionSelect
      field={field}
      onChange={onChange}
      value={criterion}
      allowedFields={allowedFields}
      criteria={criteria}
      {...props}
    />
  );
};
